"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var WordCardRowExpandedWrapper = function WordCardRowExpandedWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _Class;
  return (0, _mobxReact.observer)(_class = (_class2 = (_Class = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _props$word, _props$word2;
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "showConceptSpinner", _descriptor, _this);
      _initializerDefineProperty(_this, "showSentenceSpinner", _descriptor2, _this);
      _this.loadConcept = function (conceptId) {
        _state.DeckUI.conceptSentenceStore.clearIndexData();
        _state.DeckUI.conceptSentenceStore.clearFilter();
        _state.DeckUI.conceptSentenceStore.setPage(1);
        if (_state.DeckUI.conceptStore.hasShowData) {
          _state.DeckUI.conceptStore.clearShowData();
        }
        _this.getConcept(conceptId);
      };
      _this.afterGetSentences = function (resp) {
        if (_this._unmounted) {
          return;
        }
        _this.showSentenceSpinner = false;
        _state.DeckUI.wordSentenceStore.setIndexData(resp);
      };
      _this.getConcept = function (conceptId) {
        _this.showConceptSpinner = true;
        _this.showSentenceSpinner = true;
        _state.DeckUI.conceptStore.getShow({
          queryStrings: {
            frontend: true
          },
          ids: {
            conceptId: conceptId
          }
        }, _this.afterGetConcept);
        _state.DeckUI.conceptSentenceStore.getIndex({
          limit: _this.props.pageLength,
          ids: {
            conceptId: conceptId
          }
        }, _this.afterGetConceptSentences);
      };
      _this.afterGetConceptSentences = function (resp) {
        if (_this._unmounted) {
          return;
        }
        _state.DeckUI.conceptSentenceStore.afterGetIndex(resp);
        _this.showSentenceSpinner = false;
      };
      _this.afterGetConcept = function (resp) {
        if (_this._unmounted) {
          return;
        }
        _state.DeckUI.conceptStore.setShowData(resp);
        _this.showConceptSpinner = false;
      };
      if (props.willReceiveSentences) {
        return _possibleConstructorReturn(_this);
      }
      if (props.concept) {
        _this.showConceptSpinner = true;
        _this.showSentenceSpinner = true;
      } else if ((_props$word = props.word) !== null && _props$word !== void 0 && _props$word.id && (_props$word2 = props.word) !== null && _props$word2 !== void 0 && _props$word2.hasSentences) {
        _this.showSentenceSpinner = true;
      }
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "conceptShowMatchesProps",
      get: function get() {
        if (!this.props.concept || !_state.DeckUI.conceptStore.hasShowData) {
          return false;
        }
        return _state.DeckUI.conceptStore.showData.id === this.props.concept.id;
      }
    }, {
      key: "grammarDescriptionConcept",
      get: function get() {
        return this.conceptShowMatchesProps ? _state.DeckUI.conceptStore.showData : this.props.concept;
      }
    }, {
      key: "htmlDescription",
      get: function get() {
        return this.conceptShowMatchesProps ? _state.DeckUI.conceptStore.showData.longDescription : this.props.htmlDescription;
      }
    }, {
      key: "markdownDescription",
      get: function get() {
        return this.conceptShowMatchesProps ? _state.DeckUI.conceptStore.showData.longDescriptionMd : this.props.markdownDescription;
      }
    }, {
      key: "store",
      get: function get() {
        if (this.props.willReceiveSentences) {
          return null;
        }
        return this.props.concept ? _state.DeckUI.conceptSentenceStore : _state.DeckUI.wordSentenceStore;
      }
    }, {
      key: "sentences",
      get: function get() {
        return (0, _utils.isPresent)(this.store) ? this.store.indexData : this.props.sentences;
      }
    }, {
      key: "displaySentences",
      get: function get() {
        if (this.props.hideSentences) {
          return false;
        }
        if (this.props.concept) {
          return this.conceptShowMatchesProps && _state.DeckUI.conceptStore.showData.displaySentences;
        }
        return !!this.props.word;
      }
    }, {
      key: "showSpinner",
      get: function get() {
        return this.showConceptSpinner || this.showSentenceSpinner;
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        this._unmounted = false;
        if (this.props.willReceiveSentences) {
          return;
        }
        if (this.props.word && this.props.word.id && this.props.word.hasSentences) {
          _state.DeckUI.wordSentenceStore.clearIndexData();
          _state.DeckUI.wordSentenceStore.clearFilter();
          _state.DeckUI.wordSentenceStore.setPage(1);
          _state.DeckUI.wordSentenceStore.getIndex({
            limit: this.props.pageLength,
            ids: {
              wordId: this.props.word.id
            }
          }, this.afterGetSentences);
        } else if (this.props.concept) {
          this.loadConcept(this.props.concept.id);
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.concept && prevProps.concept.id != this.props.concept.id) {
          this.loadConcept(this.props.concept.id);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this._unmounted = true;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          store: this.store,
          sentences: this.sentences,
          getConcept: this.getConcept,
          showSpinner: this.showSpinner,
          showConceptSpinner: this.showConceptSpinner,
          showSentenceSpinner: this.showSentenceSpinner,
          displaySentences: this.displaySentences,
          grammarDescriptionConcept: this.grammarDescriptionConcept,
          htmlDescription: this.htmlDescription,
          markdownDescription: this.markdownDescription
        }));
      }
    }]);
  }(_react["default"].Component), _Class.defaultProps = {
    pageLength: 10
  }, _Class), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showConceptSpinner", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "showSentenceSpinner", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "conceptShowMatchesProps", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "conceptShowMatchesProps"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "grammarDescriptionConcept", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "grammarDescriptionConcept"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "htmlDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "htmlDescription"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "markdownDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "markdownDescription"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "store", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "store"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sentences", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sentences"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "displaySentences", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "displaySentences"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSpinner"), _class2.prototype), _class2)) || _class;
};
WordCardRowExpandedWrapper.displayName = 'WordCardRowExpandedWrapper';
var _default = exports["default"] = WordCardRowExpandedWrapper;